/**
 * Contact Form 2026 (Shopify Forms ID 1119086) — Shadow DOM integration.
 * Fallback stylesheet injection + name/email class tags for 2-col grid (no DOM moves).
 */
(function () {
  const FORM_ID = '1119086';
  const FORM_ROOT_SELECTOR = '[data-forms-id="forms-root-' + FORM_ID + '"]';
  const STYLE_ID = 'bb-contact-form-2026-styles';
  const STYLE_KEY = 'bb-contact-form-2026';

  const shell = document.querySelector('.contact-info-panel__form-shell[data-bb-contact-form-id="' + FORM_ID + '"]');
  if (!shell) return;

  const cssUrl = shell.getAttribute('data-bb-contact-form-css');
  if (!cssUrl) return;

  let cssTextPromise;

  function getCssText() {
    if (!cssTextPromise) {
      cssTextPromise = fetch(cssUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load Contact Form 2026 CSS');
          return response.text();
        })
        .catch(function () {
          return '';
        });
    }

    return cssTextPromise;
  }

  function getLayoutRoot(shadowRoot) {
    return (
      shadowRoot.querySelector('[data-testid="fields-container"]') ||
      shadowRoot.querySelector('form') ||
      shadowRoot.querySelector('[class*="_inline"]') ||
      shadowRoot.querySelector('[data-testid="form-container"]') ||
      shadowRoot.querySelector('section') ||
      shadowRoot.firstElementChild
    );
  }

  function findFieldWrapper(input, layoutRoot) {
    let node = input;

    while (node && node !== layoutRoot) {
      if (node.parentElement === layoutRoot) return node;
      node = node.parentElement;
    }

    return (
      input.closest('[data-testid="field-wrapper"]') ||
      input.closest('[class*="formField"]') ||
      input.parentElement
    );
  }

  function getLabelText(input, shadowRoot) {
    if (!input.id) return '';
    const label = shadowRoot.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    return label ? label.textContent.trim().toLowerCase() : '';
  }

  function isLayoutTagged(layoutRoot) {
    return (
      layoutRoot.classList.contains('bb-cf-fields-layout') &&
      layoutRoot.querySelector('.bb-cf-field--name') &&
      layoutRoot.querySelector('.bb-cf-field--email')
    );
  }

  function stripFormInputFieldClasses(shadowRoot) {
    shadowRoot.querySelectorAll('[class*="_formInputField_"]').forEach(function (el) {
      if (el.closest('[class*="_selectContainer_"]') || el.querySelector('[class*="_selectContainer_"]')) {
        return;
      }

      el.classList.forEach(function (className) {
        if (className.indexOf('_formInputField_') === 0) {
          el.classList.remove(className);
        }
      });
    });
  }

  function hideNativeSelects(shadowRoot) {
    shadowRoot.querySelectorAll('button[class*="_selectToggle_"], [class*="_selectContainer_"]').forEach(function (toggle) {
      const parent = toggle.closest('[class*="_selectContainer_"]') || toggle.closest('[data-testid="field-wrapper"]') || toggle.parentElement;
      if (parent) {
        parent.querySelectorAll('select').forEach(function (select) {
          select.style.display = 'none';
        });
      }
    });
  }

  function tagNameEmailFields(shadowRoot) {
    const layoutRoot = getLayoutRoot(shadowRoot);
    if (!layoutRoot || isLayoutTagged(layoutRoot)) return;

    const inputs = shadowRoot.querySelectorAll('input:not([type="hidden"])');
    let nameWrap = null;
    let emailWrap = null;

    inputs.forEach(function (input) {
      const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
      const nameAttr = (input.getAttribute('name') || '').toLowerCase();
      const ariaLabel = (input.getAttribute('aria-label') || '').toLowerCase();
      const labelText = getLabelText(input, shadowRoot);
      const wrap = findFieldWrapper(input, layoutRoot);

      if (
        !emailWrap &&
        (input.type === 'email' ||
          placeholder.includes('email') ||
          nameAttr.includes('email') ||
          ariaLabel.includes('email') ||
          labelText.includes('email'))
      ) {
        emailWrap = wrap;
      }

      if (
        !nameWrap &&
        (placeholder.includes('full name') ||
          ariaLabel.includes('full name') ||
          labelText.includes('full name') ||
          (input.autocomplete === 'name' && !placeholder.includes('company')))
      ) {
        nameWrap = wrap;
      }
    });

    if (!nameWrap || !emailWrap) return;

    layoutRoot.classList.add('bb-cf-fields-layout');
    nameWrap.classList.add('bb-cf-field--name');
    emailWrap.classList.add('bb-cf-field--email');
  }

  function injectStyles(shadowRoot, cssText) {
    if (!cssText) return;

    let style = shadowRoot.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      shadowRoot.appendChild(style);
    }
    style.textContent = cssText;
  }

  function findEmbed() {
    const formRoot = shell.querySelector(FORM_ROOT_SELECTOR) || shell.querySelector('shopify-forms-embed, form-embed');
    if (!formRoot) return null;
    if (formRoot.matches('shopify-forms-embed, form-embed')) return formRoot;
    return formRoot.querySelector('shopify-forms-embed, form-embed');
  }

  function enhanceEmbed(embed, cssText) {
    if (!embed.shadowRoot) return false;

    injectStyles(embed.shadowRoot, cssText);
    stripFormInputFieldClasses(embed.shadowRoot);
    hideNativeSelects(embed.shadowRoot);
    tagNameEmailFields(embed.shadowRoot);
    return true;
  }

  function observeShadow(embed) {
    if (!embed.shadowRoot) return;

    const shadowObserver = new MutationObserver(function () {
      stripFormInputFieldClasses(embed.shadowRoot);
      hideNativeSelects(embed.shadowRoot);
      tagNameEmailFields(embed.shadowRoot);
    });

    shadowObserver.observe(embed.shadowRoot, { childList: true, subtree: true });
    window.setTimeout(function () {
      shadowObserver.disconnect();
    }, 20000);
  }

  function enhance() {
    const embed = findEmbed();
    if (!embed) return Promise.resolve(false);

    return getCssText().then(function (cssText) {
      if (!cssText) return false;

      window.formStyles = window.formStyles || new Map();
      if (!window.formStyles.has(STYLE_KEY)) {
        window.formStyles.set(STYLE_KEY, cssText);
      }

      if (embed.shadowRoot) {
        enhanceEmbed(embed, cssText);
        observeShadow(embed);
        return true;
      }

      return false;
    });
  }

  enhance().then(function (done) {
    if (done) return;

    const shellObserver = new MutationObserver(function () {
      const embed = findEmbed();
      if (embed && embed.shadowRoot) {
        getCssText().then(function (cssText) {
          if (cssText) enhanceEmbed(embed, cssText);
          observeShadow(embed);
        });
      }
    });

    shellObserver.observe(shell, { childList: true, subtree: true });
    window.setTimeout(function () {
      shellObserver.disconnect();
    }, 20000);
  });
})();
